import { createDevStore } from 'bpm/shared/utils/devtools'
import { StateCreator, create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type PSEInfoDialogType = {
    isExpanded: boolean
    setIsExpanded: (isExpanded: boolean) => void
}

const store = createDevStore(
    persist(
        (set) => ({
            isExpanded: true,
            setIsExpanded: (isExpanded: boolean) => set({ isExpanded }),
        }),
        {
            name: 'pse-info-dialog',
            storage: createJSONStorage(() => localStorage),
        }
    ) as StateCreator<PSEInfoDialogType, [], [['zustand/persist', unknown]]>,
    'PSE-INFO-DIALOG'
)

export const usePSEInfoDialogStore = create(store)
